import React from 'react';
import moment from 'moment';
import { TextField, InputAdornment, InputBase, withStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const styles = (theme) => ({
  root: {
    margin: '5px 0px',
    padding: '5px 10px',
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#DBE1E4',
  },
  input: {
    fontSize: 14,
    color: '#8DA1AB',
  },
});

const Search = ({
  onChange,
  placeholder,
  fullWidth,
  variant = 'textField',
  color,
  width,
  classes,
  theme,
  ...rest
}) =>
  variant === 'textField' ? (
    <TextField
      placeholder={placeholder || 'Cari . . .'}
      onChange={(event) => onChange(event.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FontAwesomeIcon icon="search" size="sm" color="#8DA1AB" />
          </InputAdornment>
        ),
      }}
      style={fullWidth ? { width: '100%' } : width ? { width } : {}}
      {...rest}
    />
  ) : (
    <InputBase
      placeholder={placeholder || 'Cari . . .'}
      onChange={(event) => onChange(event.target.value)}
      startAdornment={
        <InputAdornment position="start">
          <FontAwesomeIcon icon="search" size="sm" color="#8DA1AB" />
        </InputAdornment>
      }
      style={{
        marginBottom: 25,
        width: fullWidth ? 'calc(100% - 20px)' : width || 'unset',
        backgroundColor: color || theme.palette.background.default,
      }}
      className={classes.root}
      classes={{
        input: classes.input,
      }}
      {...rest}
    />
  );

export const searchFilter = (keyword) => (data) =>
  keyword
    ? data.filter((item) => {
        for (const [key, value] of Object.entries(item)) {
          const isInclude = checkInclude(keyword, key, value);
          if (isInclude) return true;
        }
        return false;
      })
    : data;

const sorting = (x, y, type) => {
  if (isNaN(parseInt(x)) || isNaN(parseInt(x))) {
    if (type === 'ascending') {
      if (x > y) {
        return 1;
      }
      if (x < y) {
        return -1;
      }
      return 0;
    } else {
      if (x > y) {
        return -1;
      }
      if (x < y) {
        return 1;
      }
      return 0;
    }
  } else {
    const a = parseInt(x);
    const b = parseInt(y);
    if (type === 'ascending') {
      return a - b;
    } else {
      return b - a;
    }
  }
};

const deepSort = (strA, strB, index, type) => {
  const a = strA[index] && strA[index].toLowerCase();
  const b = strB[index] && strB[index].toLowerCase();
  if (a === b) {
    if (strA.length - 1 > index + 1 || strB.length - 1 > index + 1) {
      return deepSort(strA, strB, index + 1, type);
    } else {
      const x = strA[index + 1] && strA[index + 1].toLowerCase();
      const y = strB[index + 1] && strB[index + 1].toLowerCase();
      return sorting(x, y, type);
    }
  } else {
    return sorting(a, b, type);
  }
};

export const sortFilter = (name, sortType, data) => {
  if (name) {
    if (sortType === 'ascending') {
      return data.sort((a, b) => {
        if (typeof a[name] === 'number') {
          return a[name] - b[name];
        } else {
          const strA = a[name] ? a[name].match(/[a-z]+|[^a-z]+/gi) : [];
          const strB = b[name] ? b[name].match(/[a-z]+|[^a-z]+/gi) : [];

          return deepSort(strA, strB, 0, sortType);

          // return deepSort(strA, strB, 0, sortType);
          // const x = a[name] && a[name].toLowerCase();
          // const y = b[name] && b[name].toLowerCase();
          // if(x > y){
          // 	return 1
          // }
          // if(x < y){
          // 	return -1
          // }
          // return 0
        }
      });
    } else {
      return data.sort((a, b) => {
        if (typeof a[name] === 'number') {
          return b[name] - a[name];
        } else {
          const strA = a[name] ? a[name].match(/[a-z]+|[^a-z]+/gi) : [];
          const strB = b[name] ? b[name].match(/[a-z]+|[^a-z]+/gi) : [];

          return deepSort(strA, strB, 0, sortType);

          // const x = a[name] && a[name].toLowerCase();
          // const y = b[name] && b[name].toLowerCase();
          // if(x > y){
          // 	return -1
          // }
          // if(x < y){
          // 	return 1
          // }
          // return 0
        }
      });
    }
  } else {
    return data;
  }
};

export const multipleFilter = (select, data) => {
  let employeesData = data;
  const seletedCategory = { ...select };

  // delete false value
  Object.keys(seletedCategory).forEach((key) => {
    if (!seletedCategory[key]) {
      delete seletedCategory[key];
    }
  });

  if (seletedCategory.inActive) {
    seletedCategory.isActive = false;
    if (select.isActive) {
      delete seletedCategory.isActive;
    }
    delete seletedCategory.inActive;
  }

  if (Object.keys(seletedCategory).length === 0) {
    return data;
  }

  employeesData =
    seletedCategory.isActive !== undefined
      ? employeesData.filter((item) => item.isActive === seletedCategory.isActive)
      : employeesData;

  if (Object.keys(seletedCategory).length === 1 && seletedCategory.isActive !== undefined) {
    return employeesData;
  }

  delete seletedCategory.isActive;

  return employeesData.filter((item) => {
    for (const key in seletedCategory) {
      if (item[key] === seletedCategory[key]) {
        return true;
      }
    }
    return false;
  });

  // return if match all criteries
  // return data.filter((item) => {
  //   for (const key in select) {
  //     if (item[key] === undefined || item[key] !== select[key]) { return false; }
  //   }
  //   return true;
  // });
};

const checkInclude = (keyword, key, value) => {
  if (Array.isArray(value)) {
    const isInclude = deepCheckArray(keyword, value);
    if (isInclude) return true;
  } else if (value && typeof value === 'object') {
    const isInclude = deepCheckObject(keyword, value);
    if (isInclude) return true;
  } else {
    if (key === 'superiorName' || key === 'superiorNip') return false;
    if (
      (key &&
        key === 'timestamp' &&
        moment(value).format('L HH:mm:ss').includes(keyword.toLowerCase())) ||
      String(value).toLowerCase().includes(keyword.toLowerCase())
    ) {
      return true;
    }
  }
};

const deepCheckArray = (keyword, data) => {
  for (const value of data) {
    const isInclude = checkInclude(keyword, null, value);
    if (isInclude) return true;
  }
  return false;
};

const deepCheckObject = (keyword, data) => {
  for (const [key, value] of Object.entries(data)) {
    const isInclude = checkInclude(keyword, key, value);
    if (isInclude) return true;
  }
  return false;
};

export default withStyles(styles, { withTheme: true })(Search);
